module.exports = __webpack_public_path__ + "./images/1804118bae5d8f2ecc78d4e0e3eafbd0.webp";